<template>
	<div
		class="widget-footer"
		id="widget-footer"
		:class="[!enabledInput || captureLead ? 'disable' : '']"
	>
		<div class="type-message" :style="`opacity:${isEndedConvo ? '0' : '1'}`">
			<input
				class="file-input"
				ref="fileInput"
				type="file"
				@change="sendFile"
				multiple
			/>
			<div id="message" ref="messageInputWrapper">
				<textarea
					id="msg"
					ref="messageInput"
					:placeholder="$t('message_input_help')"
					class="keyup"
					rows="1"
					:style="msgInputStyle"
					@paste="pasteImage"
					data-emojiable="true"
					v-model="message"
					@keydown="onKeydown"
					@focus="onfocusInput"
					@blur="onblurInput"
					@keyup="onKeyup"
				>
				</textarea>
			</div>

			<sb-emoji></sb-emoji>
			<div class="attach-file" @click.stop="selectFile">
				<v-icon name="paperclip" scale="1.0" fill="#AAA" />
			</div>
		</div>

		<div class="bottom">
			<div class="brand" id="brand" :style="brandStyle">
				{{ $t('powered_by') }}
				<a :href="referralURL" target="_blank"><strong>Subiz</strong></a>
			</div>

			<div
				class="send-message"
				id="submit"
				:class="[message != '' ? 'visible' : 'invisible']"
			>
				<a href="javascript:void(0)" @click="submitMessage()">
					<v-icon name="paper-plane" />
					{{ $t('send_message') }}
				</a>
			</div>
		</div>
	</div>
</template>

<script>
import { Client, Server } from '../client_server.js'
import Emoji from '../components/Emoji.vue'
import * as utils from '../utils'
import * as types from '../store/mutation_types'
import eventHub from '../lib/hub'
import bowser from 'bowser'
import { mapState } from 'vuex'
import dayjs from 'dayjs'
import store from '../store'
const g_client = new Client('widget_4_parent', window.parent)

export default {
  name: 'msg-input',
  props: ['blockInputMessage', 'isBlankConvo'],
  components: {
    'sb-emoji': Emoji
  },

  data () {
    return {
      message: '',
      msgInputStyle: {
        height: '33px'
      },
      enabledInput: true,
      captureLead: false
    }
  },

  computed: {
    ...mapState([
      'conversations',
      'themeColor'
    ]),

    userId () {
      return store.state.user.id
    },

    accountId () {
      return store.state.account.id
    },

    convoId () {
      return this.$route.params.convoId || ''
    },

    isEndedConvo () {
      const convoId = this.$route.params.convoId || ''
      const convo = store.getters.getConvoById(convoId)
      if (convo && convo.id && convo.state === 'ended') {
        this.$nextTick(() => {
          const input = this.$refs.messageInput
          input.blur()
        })
        return true
      }

      return false
    },

    referralURL () {
      return `https://subiz.com/?utm_source=id-${this.accountId}&utm_medium=widget&utm_campaign=widget_referral`
    },

    brandStyle () {
      const style = {
        display: 'none !important'
      }

      if (this.message === '') {
        style.display = 'block'
      }

      return style
    }
  },

  mounted () {
    const input = this.$refs.messageInput
    this.$nextTick(function () {
      this.resizeInput()
      if (this.isBlankConvo) {
        input.style.border = `1px ${this.themeColor} dashed`
      } else {
        input.style.border = `none`
      }
    })
    if (this.blockInputMessage) {
      this.captureLead = true
    }

    if (!this.isEndedConvo && this.enabledInput && !bowser.mobile && !this.captureLead) {
      input.focus()
    }
  },

  methods: {
    throttleOnEnter: utils.throttle(function () {
      this.submitMessage()
    }, 50),

    onKeyup (e) {
      if (e.keyCode === 13 && e.shiftKey === false) {
        this.throttleOnEnter()
      }
      this.resizeInput()
      this.sendTyping()
    },

    onKeydown (e) {
      if (e.keyCode === 13 && e.shiftKey === false) {
        e.preventDefault()
      }
    },

    activeInputMessage (status) {
      this.captureLead = status
      const input = this.$refs.messageInput
      if (status) {
        input.blur()
        // this.message = ''
      } else {
        input.focus()
      }
    },

    selectFile () {
      this.$refs.fileInput.click()
    },

    sendFile () {
      const files = this.$refs.fileInput.files
      utils.log('files:', files)

      this._sendFile(files)
    },

    async _sendFile (files) {
      eventHub.$emit('widget.message_sending', true)

      const accountId = this.accountId
      const userId = this.userId

      const result = await store.dispatch('uploadFileToS3', { accountId, files })
      utils.log('upload result:', result)

      let convoId = this.$route.params.convoId || ''

      if (!convoId) {
        this.enabledInput = false

        const extraData = {
          page_title: store.state.parent_title || '',
          page_url: store.state.parent_href || '',
          timezone: utils.getTimezone(),
          channel_type: 'widget',
          browser_language: window.navigator.language || ''
        }

        const convo = await store.dispatch('startConversation', { accountId, userId, extraData })
        convoId = convo.id
      }

      const attachments = []

      for (let file of result) {
        const attachment = {
          type: 'file',
          mimetype: file.type,
          url: utils.absURL(file.url),
          name: file.name,
          size: file.size
        }

        attachments.push(attachment)
      }

      const message = {
        account_id: accountId,
        type: 'message_sent',
        object: 'message',
        data: {
          message: {
            attachments
          }
        }
      }

      await store.dispatch('sendMessage', { accountId, convoId, message })

      if (!this.convoId) {
        this.$router.push({ name: 'convo', params: { convoId } })
      }

      eventHub.$emit('widget.message_sending', false)
      eventHub.$emit('widget.message_sent')

      this.enabledInput = true

      // reset file input to re-select the same file
      this.$refs.fileInput.value = ''
    },

    async submitMessage (quickReplyText) {
      let conversations = this.conversations
      let accountId = this.accountId
      let convoId = this.convoId
      let userId = this.userId
      let message = this.message
      if (quickReplyText) message = quickReplyText
      utils.log('send Message:', message)
      let isValid = this.validateMessage(conversations, message, convoId)
      if (!isValid) return
      convoId = await this.sendMessage(accountId, convoId, userId, message)
      this.afterSendMessage(convoId)
    },

    async sendMessage (accountId, convoId, userId, messageText) {
      eventHub.$emit('widget.message_sending', true)
      utils.sendEventToThirdParty(g_client, 'SUBIZ Chat', 'Sent', 'User')

      if (!convoId) {
        const convo = await store.dispatch('startConversation', { accountId, userId })
        convoId = convo.id
      }

      const message = {
        account_id: accountId,
        type: 'message_sent',
        object: 'message',
        data: {
          message: {
            text: messageText.trim(),
            format: 'plaintext'
          }
        },
        by: {
          device: store.state.device
        }
      }

      await store.dispatch('sendMessage', { accountId, convoId, message })

      eventHub.$emit('widget.message_sending', false)
      eventHub.$emit('widget.message_sent')
      return convoId
    },

    validateMessage (conversations, message, convoId) {
      let messageText = message.trim()
      let convoHasEndEvent = conversations.find(convo => convo.id === convoId && convo.state === 'ended')

      if (!messageText || convoHasEndEvent) {
        return false
      }
      // reset input
      this.message = ''
      const input = this.$refs.messageInput
      input.focus()
      if (!convoId) {
        this.enabledInput = false
        input.blur()
      }
      return true
    },

    afterSendMessage (convoId) {
      const input = this.$refs.messageInput
      this.enabledInput = true
      if (!this.captureLead) {
        input.focus()
      }

      this.msgInputStyle.height = '33px'

      if (convoId) {
        this.$router.push({ name: 'convo', params: { convoId } })
      }
    },

    resizeInput: utils.throttle(function () {
      utils.log('resize Input')

      const _this = this

      this.msgInputStyle.height = '0px'

      this.$nextTick(function () {
        const input = _this.$refs.messageInput
        const inputWrapper = _this.$refs.messageInputWrapper

        const height = Math.min(20 * 5, input.scrollHeight)

        inputWrapper.style.cssText = 'height:' + height + 'px'
        _this.msgInputStyle.height = height + 'px'
      })
    }, 5),

    insertEmoji (name) {
      const code = `:${name}:`
      const input = this.$refs.messageInput
      const position = input.selectionStart
      const message = this.message
      this.message = [message.slice(0, position), code, message.slice(position)].join('')
      input.focus()
    },

    sendTyping: utils.throttle(function () {
      if (!this.convoId) return
      store.dispatch('sendTyping', { convoId: this.convoId })
    }, 3000),

    pasteImage (event) {
      utils.log('event', event)

      if (!window.File || !window.FileReader || !window.FileList || !window.Blob) {
        utils.log('The File APIs are not fully supported in this browser.')
        return
      }

      if (utils.isEmpty(event.clipboardData.items)) {
        utils.log('not support')
        return
      }

      const name = `Paste-image-${dayjs(new Date()).format('YYYY-MM-DD-HH-mm-ss')}`
      let blob = null
      const copiedData = event.clipboardData.items[0]
      if (copiedData.type.indexOf('image') === 0) {
        blob = copiedData.getAsFile()
      }

      if (!blob) {
        utils.log('paste image: no data')
        return
      }

      const parts = [blob, new ArrayBuffer()]
      const file = new File(parts, `${name}.png`, { type: 'image/png' })

      this._sendFile([file])
    },

		onfocusInput () {
      store.commit(types.SET_FOCUSMESSAGEINPUT, true)
    },

    onblurInput () {
      store.commit(types.SET_FOCUSMESSAGEINPUT, false)
     },
  },

  watch: {
    message (value) {
      const length = 1024
      if (value.length > length) {
        this.message = utils.truncate(value, length, '')
      }
    },
    isBlankConvo (isBlank) {
      if (isBlank) {
        this.$refs.messageInput.style.border = `1px ${this.themeColor} dashed`
      } else {
        this.$refs.messageInput.style.border = `none`
      }
    }
  }
}
</script>
